import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import cn from 'classnames';
import { Section } from '../reportView';
import classes from '../WorkEnvironmentReport.module.css';

type Props = {
  section: Section;
  intro?: string;
  /** The summary opens the report, so its heading is only for screen readers */
  hiddenHeading?: boolean;
  children: ReactNode;
};

export const ReportSection = ({ section, intro, hiddenHeading = false, children }: Props): ReactElement => {
  const { t } = useTranslation();
  return (
    <section id={`report-${section}`} aria-labelledby={`report-${section}-heading`} className={classes.section}>
      <div className={cn(classes.sectionHead, { 'ds-sr-only': hiddenHeading })}>
        <Heading level={2} data-size="sm" id={`report-${section}-heading`}>
          {t(`workEnvironmentReport.sections.${section}`)}
        </Heading>
        {intro && (
          <Paragraph data-size="sm" className={classes.sectionIntro}>
            {intro}
          </Paragraph>
        )}
      </div>
      {children}
    </section>
  );
};
